import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { LinkCardList } from "@tvg/design-system/web";
import { SeparatedPools, TopPool } from "@tvg/ts-types/Pool";
import { getCapiMessageContent } from "../../redux/selectors";
import { Props } from "./types";
import { QA_LABEL } from "../../qaLabels";
import { getSeparedPools } from "../../utils";
import TopPoolsList from "./TopPoolsList";
import { PoolItemContainer } from "./styled-components";

const DesktopView = ({ pools, onPoolClick }: Props) => {
  const { highlightsTitle, upcomingTitle, numTPoolsCardstoShowInHP } =
    useSelector(getCapiMessageContent);
  const [separatedPools, setSeparatedPools] = React.useState<SeparatedPools>({
    highligthedPools: [],
    upComingPools: []
  });

  useEffect(() => {
    const topPools = pools.slice(0, numTPoolsCardstoShowInHP);
    const separatedPoolsResult = getSeparedPools(topPools);
    setSeparatedPools(separatedPoolsResult);
  }, [pools]);

  const renderItems = (title: string, selectedTopPools: TopPool[]) => (
    <TopPoolsList
      title={title}
      topPools={selectedTopPools}
      onPoolClick={onPoolClick}
    />
  );

  const { highligthedPools, upComingPools } = separatedPools;
  return (
    <PoolItemContainer>
      <LinkCardList qaLabel={QA_LABEL.body.desktop.list}>
        {highligthedPools.length > 0 &&
          renderItems(highlightsTitle, highligthedPools)}
      </LinkCardList>

      <LinkCardList qaLabel={QA_LABEL.body.desktop.list}>
        {highligthedPools.length < numTPoolsCardstoShowInHP &&
          upComingPools.length > 0 &&
          renderItems(upcomingTitle, upComingPools)}
      </LinkCardList>
    </PoolItemContainer>
  );
};

export default DesktopView;
